<input
  *ngIf="props.type !== 'number'; else numberTmp"
  nz-input
  [formControl]="formControl"
  [nzVariant]="props.variant || 'outlined'"
  [nzSize]="props.size || 'default'"
  [type]="props.type || 'text'"
  [formlyAttributes]="field"
  (ngModelChange)="onValueChange$.next($event)" />
<ng-template #numberTmp>
  <nz-input-number
    [formControl]="formControl"
    [formlyAttributes]="field"
    [nzSize]="props.size || 'default'"
    (ngModelChange)="onValueChange$.next($event)"></nz-input-number>
</ng-template>
